// Copyright (c) 2022 Enabler Interactive Pty Ltd

import React, { Component } from 'react'
import { Link } from 'react-router'
import { Col, Clearfix, Table, Button, Row, FormGroup, FormControl, Panel, OverlayTrigger, Tooltip } from 'react-bootstrap'
import { BsSortUp, BsSortDown } from 'react-icons/bs'
import { Message } from '../components/message'
import { Loading } from '../components/loading'
import config from '../config/config.json'
import { evalDateHour, evalDateDay, evalRatingModule, evalRatingClass } from '../utils/enUtils.js'

export class PerformanceSummary extends Component {
    constructor(props) {
        super(props)

        this.getWorkersByProvider(this.props.env, config)

        this.state = {
            workers: [],
            officialResults: [{
                workerId: 0,
                results: []
            }],
            moduleFilter: 'All',
            statusFilter: 'All',
            dueDateFilter: 'All',
            searchString: '',
            filteredResults: [],
            sortColumn: 'worker',
            sortOrder: 'asc',
            currentDate: evalDateHour(Date.now()),
            workerData: [],
            loading: true
        }

        this.init = this.init.bind(this)
        this.getWorkersByProvider = this.getWorkersByProvider.bind(this)
        this.displayRecords = this.displayRecords.bind(this)
        this.getOfficialResults = this.getOfficialResults.bind(this)
        this.printReport = this.printReport.bind(this)
        this.downloadCSV = this.downloadCSV.bind(this)
        this.getWorkerData = this.getWorkerData.bind(this)
        this.filterStatus = this.filterStatus.bind(this)
        this.searchWorker = this.searchWorker.bind(this)
        this.loadModulesDisplay = this.loadModulesDisplay.bind(this)
        this.filterModule = this.filterModule.bind(this)
        this.filterDueDate = this.filterDueDate.bind(this)
        this.handleWorkerClick = this.handleWorkerClick.bind(this)
        this.handleModuleClick = this.handleModuleClick.bind(this)
        this.sortColumn = this.sortColumn.bind(this)
        this.sortIcon = this.sortIcon.bind(this)

        this.getWorkerData()
    }

    init() {
        if (!window.sessionStorage.getItem('authToken')) {
            console.log("not logged in")
            this.props.router.push('/login')
            return
        }

        if (this.props.appData.authToken === '') {
            let storedData = window.sessionStorage

            let data = {
                profileType: storedData.profileType,
                loginStatus: storedData.loginStatus,
                authToken: storedData.authToken,
                id: storedData.uid,
                admin_first_name: storedData.fname,
                admin_last_name: storedData.lname,
                name: storedData.company,
                address: storedData.address,
                license_count: storedData.licenseCount,
                globalModules: JSON.parse(storedData.globalModules)
            }

            this.props.handleProviderDataUpdateFromSessionStorage(data)
        }
    }

    getWorkerData() {
        let workerData = []

        if (this.state.workers.length === 0)
            return

        this.state.workers.forEach((worker) => {
            worker.enabler_modules.forEach((module) => {
                // Original raw date format strings are required for column sorting
                let last_result = this.getLastOfficialResults(worker.id, module.name)
                let lastResult = evalDateDay(last_result)
                let due_date = module.due_date
                let dueDate = evalDateDay(due_date)

                // Flatten worker data by module
                let tempWorkerData = {
                    'workerId': worker.id,
                    'name': worker.first_name + " " + worker.last_name,
                    'email': worker.email,
                    'module': module.name,
                    'status': evalRatingModule(module.completed, module.average_strikes),
                    'completed': module.completed,
                    'last_result': last_result || '',
                    'lastResult': lastResult || '',
                    'due_date': due_date || '',
                    'dueDate': dueDate || '',
                    'overdue': module.overdue
                }

                workerData.push(tempWorkerData)
            })
        })

        this.setState({
            workerData,
            filteredResults: workerData
        })
    }

    getWorkersByProvider(env, config) {
        fetch(config[env] + config.api.list_workers.endpoint, {
            method: config.api.list_workers.type,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': this.props.appData.authToken || window.sessionStorage.authToken
            }
        }).then((response) => response.json())
            .then((responseJson) => {
                let workerIds = []

                responseJson.workers.forEach(worker => {
                    workerIds.push(worker.id)
                })

                this.getOfficialResults(workerIds, env, config, responseJson)
                this.setState({
                    workers: responseJson.workers
                })

                this.props.handleLoadWorkers(responseJson.workers)
            })
            .catch((error) => {
                console.error(error)
            })
    }

    filterDueDate(e) {
        this.setState({
            dueDateFilter: e.target.value
        })
    }

    filterStatus(e) {
        this.setState({
            statusFilter: e.target.value
        })
    }

    filterModule(e) {
        this.setState({
            moduleFilter: e.target.value
        })
    }

    searchWorker(e) {
        this.setState({
            searchString: e.target.value
        })
    }

    displayRecords() {
        return (
            <Table responsive bsClass="table">
                <thead>
                    <tr>
                        <th id="worker" onClick={this.sortColumn} className="sort-column">Worker {this.sortIcon("worker")}</th>
                        <th id="module" onClick={this.sortColumn} className="sort-column">Module {this.sortIcon("module")}</th>
                        <th id="status" onClick={this.sortColumn} className="sort-column">Status {this.sortIcon("status")}</th>
                        <th id="dueDate" onClick={this.sortColumn} className="sort-column">Due Date {this.sortIcon("dueDate")}</th>
                        <th id="lastOfficialResult" onClick={this.sortColumn} className="sort-column">Last Official Result {this.sortIcon("lastOfficialResult")}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr className="filter-panel">
                        <td>
                            <form id="search">
                                <FormGroup controlId="formSearchString">
                                    <FormControl type="text" placeholder="Search Worker" inputRef={ref => { this.searchInput = ref }} onChange={this.searchWorker} />
                                </FormGroup>
                            </form>
                        </td>
                        <td>
                            <form id="filterModule">
                                <FormGroup controlId="formModuleFilter">
                                    <FormControl componentClass="select" placeholder="select" inputRef={ref => { this.moduleInput = ref }} onChange={this.filterModule}>
                                        <option value="All">All</option>
                                        {this.loadModulesDisplay()}
                                    </FormControl>
                                </FormGroup>
                            </form>
                        </td>
                        <td>
                            <form id="filterRating">
                                <FormGroup controlId="formRatingFilter">
                                    <FormControl componentClass="select" placeholder="select" inputRef={ref => { this.statusInput = ref }} onChange={this.filterStatus}>
                                        <option value="All">All</option>
                                        <option value="Excellent">Excellent</option>
                                        <option value="Good">Good</option>
                                        <option value="Pass">Pass</option>
                                        <option value="Poor">Poor</option>
                                        <option value="In Progress">In Progress</option>
                                        <option value="Not Started">Not Started</option>
                                    </FormControl>
                                </FormGroup>
                            </form>
                        </td>
                        <td>
                            <form id="filterDueDate">
                                <FormGroup controlId="formDueDateFilter">
                                    <FormControl componentClass="select" placeholder="select" inputRef={ref => { this.dueDateInput = ref }} onChange={this.filterDueDate}>
                                        <option value="All">All</option>
                                        <option value="Overdue">Overdue</option>
                                        <option value="Not Overdue">Not Overdue</option>
                                        <option value="Completed">Completed</option>
                                    </FormControl>
                                </FormGroup>
                            </form>
                        </td>
                        <td></td>
                    </tr>
                    {this.records}
                </tbody>
            </Table>
        )
    }

    loadModulesDisplay() {
        const uniqueModules = [...new Set(this.state.workerData.map(item => item.module))]

        return uniqueModules.map((uniqueModule, index) => {
            return (
                <option key={index} value={uniqueModule}>{uniqueModule}</option>
            )
        })
    }

    handleWorkerClick(e) {
        e.preventDefault()
        this.props.handleActiveWorker(e.target.getAttribute('data-id'))
        this.props.router.push('/performance/summary/content')
    }

    handleModuleClick(e) {
        e.preventDefault()
        this.props.handleActiveWorker(e.target.getAttribute('data-id'))
        this.props.handleActiveModule(e.target.getAttribute('data-name'))
        this.props.router.push('/performance/summary/content/details')
    }

    get records() {
        if (this.state.loading) {
            return (
                <Loading embedType="tbody" />
            )
        }

        if (this.state.workerData.length === 0) {
            return (
                <Message embedType="tbody" text={"No official results available for your organisation."} />
            )
        }

        let filteredList = this.getFilteredWorkers()

        return filteredList.map((workerDataItem, index) => {
            let overdue = workerDataItem.overdue && !workerDataItem.completed
            let dueStatus = "Unknown"

            if (workerDataItem.completed) {
                dueStatus = "Completed"
            } else if (overdue) {
                dueStatus = "Overdue"
            } else if (!workerDataItem.overdue && !workerDataItem.completed) {
                dueStatus = "Not Overdue"
            }

            let overdueToolip = (
                <Tooltip id={"overdueTooltip" + index}>{dueStatus}</Tooltip>
            )

            return (
                <tr key={index}>
                    <td><label>
                        <Link onClick={this.handleWorkerClick} data-id={workerDataItem.workerId}>
                            {workerDataItem.name}
                        </Link>
                        <span className="workerEmail">{workerDataItem.email}</span>
                    </label></td>
                    <td><label>
                        <Link onClick={this.handleModuleClick} data-id={workerDataItem.workerId} data-name={workerDataItem.module}>
                            {workerDataItem.module}
                        </Link>
                    </label></td>
                    <td>
                        <span className={evalRatingClass(workerDataItem.status)}>{workerDataItem.status}</span>
                    </td>
                    <td>
                        <OverlayTrigger trigger={["hover", "focus"]} placement="right" overlay={overdueToolip}>
                            <span id={"overdueDate" + index} className={overdue ? "overdue" : null}>{workerDataItem.dueDate}</span>
                        </OverlayTrigger>
                    </td>
                    <td>
                        {workerDataItem.lastResult}
                    </td>
                </tr>
            )
        })
    }

    sortColumn(e) {
        e.preventDefault()
        let columnId = e.target.getAttribute('id')

        if (this.state.sortColumn === columnId) {
            // Already sorted by this column, so invert the order
            let sortOrder = this.state.sortOrder === 'asc' ? 'desc' : 'asc'

            this.setState({
                sortOrder: sortOrder
            })
        } else {
            // Sort by this column, default order to ascending
            this.setState({
                sortColumn: columnId,
                sortOrder: 'asc'
            })
        }
    }

    sortIcon(id) {
        if (this.state.sortColumn === id) {
            if (this.state.sortOrder === 'asc') {
                return (
                    <BsSortUp className="sort-icon" />
                )
            } else {
                return (
                    <BsSortDown className="sort-icon" />
                )
            }
        }
    }

    getFilteredWorkers() {
        // Deep copy
        let filteredWorkers = JSON.parse(JSON.stringify(this.state.workerData))

        // Apply column filters
        if (this.state.dueDateFilter !== "All") {
            filteredWorkers = filteredWorkers.filter(workerDataItem => {
                if (this.state.dueDateFilter === "Completed") {
                    return workerDataItem.completed
                } else if (this.state.dueDateFilter === "Overdue") {
                    return workerDataItem.overdue && !workerDataItem.completed
                } else if (this.state.dueDateFilter === "Not Overdue") {
                    return !workerDataItem.overdue && !workerDataItem.completed
                } else {
                    return true
                }
            })
        }

        if (this.state.statusFilter !== "All") {
            filteredWorkers = filteredWorkers.filter(workerDataItem => {
                return workerDataItem.status === this.state.statusFilter
            })
        }

        if (this.state.moduleFilter !== "All") {
            filteredWorkers = filteredWorkers.filter(workerDataItem => {
                return workerDataItem.module === this.state.moduleFilter
            })
        }

        if (this.state.searchString) {
            filteredWorkers = filteredWorkers.filter(workerDataItem => {
                return (
                    (workerDataItem.name.toLowerCase()).indexOf(this.state.searchString.toLowerCase()) > -1
                    || (workerDataItem.email.toLowerCase()).indexOf(this.state.searchString.toLowerCase()) > -1
                )
            })
        }

        // Apply column sorting
        switch (this.state.sortColumn) {
            case "module":
                filteredWorkers.sort((a, b) => a.module < b.module ? -1 : 1)
                break;
            case "status":
                filteredWorkers.sort((a, b) => a.status < b.status ? -1 : 1)
                break;
            case "dueDate":
                filteredWorkers.sort((a, b) => a.due_date < b.due_date ? -1 : 1)
                break;
            case "lastOfficialResult":
                filteredWorkers.sort((a, b) => a.last_result < b.last_result ? -1 : 1)
                break;
            case "worker":
            default:
                filteredWorkers.sort((a, b) => a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1)
                break;
        }

        if (this.state.sortOrder === "desc") {
            filteredWorkers.reverse()
        }

        return filteredWorkers
    }

    getCompletionRate() {
        if (this.props.workers) {
            return `${this.props.assignmentsCompletionRate}% (${this.props.assignmentsCompleted}/${this.props.assignmentsTotal})`
        } else {
            return 0
        }
    }

    getInProgressRate() {
        if (this.props.workers) {
            return `${this.props.assignmentsInProgressRate}% (${this.props.assignmentsInProgress}/${this.props.assignmentsTotal})`
        } else {
            return 0
        }
    }

    getNotStartedRate() {
        if (this.props.workers) {
            return `${this.props.assignmentsNotStartedRate}% (${this.props.assignmentsNotStarted}/${this.props.assignmentsTotal})`
        } else {
            return 0
        }
    }

    getLastOfficialResults(workerId, moduleName) {
        let resultsByWorker = this.state.officialResults.filter(resultItem => {
            return (resultItem.worker_id === workerId)
        })

        if (resultsByWorker.length === 0)
            return

        let resultsByModule = resultsByWorker.filter(resultItem => {
            return resultItem.enabler_module === moduleName
        })

        if (resultsByModule.length > 0) {
            return (resultsByModule[0].created_at)
        }
    }

    constructURL(url, arr) {
        for (let i = 0; i < arr.length; ++i) {
            if (i === 0) {
                url = url + arr[i];
            } else {
                url = url + '&worker_ids[]=' + arr[i];
            }
        }

        return url
    }

    getOfficialResults(workerIds, env, config, workers) {
        let URL = this.constructURL(config[env] + config.api.list_official_games.endpoint, workerIds)

        fetch(URL, {
            method: config.api.list_official_games.type,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': this.props.authToken || window.sessionStorage.authToken
            }
        }).then((response) => response.json())
            .then((responseJson) => {
                this.setState({
                    officialResults: responseJson,
                    loading: false
                })

                this.getWorkerData()
            })
            .catch((error) => {
                console.error(error)
            })
    }

    printReport() {
        this.setState({
            currentDate: evalDateHour(Date.now())
        })
        setTimeout(() => { window.print() }, 1500)
    }

    downloadCSV() {
        let filteredList = this.getFilteredWorkers()

        let csv = 'Name,Email,Module,Status,Last Official Result\n';
        filteredList.forEach(function (row) {
            csv += row.name + "," + row.email + "," + row.module + "," + row.status + "," + row.lastResult + "\n"
        })

        let hiddenElement = document.createElement('a')
        hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURI(csv)
        hiddenElement.target = '_blank'
        hiddenElement.download = "Enabler Performance Report - " + this.props.appData.company + " - " + evalDateHour(Date.now()) + ".csv"
        hiddenElement.click()
    }

    render() {
        return (
            <div className="summary-container">
                <Row>
                    <Col sm={10} md={10} xs={10} smOffset={1} mdOffset={1} xsOffset={1}>
                        <div className="main-header">
                            <h2 className="title">Performance Breakdown</h2>
                            <h3 className="company-name">{this.props.appData.company}</h3>
                            <h4 className="print-date" id="print-date">Printed on: {this.state.currentDate}</h4>
                        </div>
                    </Col>
                </Row>
                <Row className="print-panel">
                    <Col sm={4} md={4} xs={10} smOffset={1} mdOffset={1} xsOffset={1}>
                        <Panel>
                            <Panel.Heading>
                                Summary
                            </Panel.Heading>
                            {(this.props.assignmentsTotal > 0) && <Panel.Body>
                                <p>Total assignments: {this.props.assignmentsTotal}</p>
                                <p>Assignments completed: {this.getCompletionRate()}</p>
                                <p>Assignments in progress: {this.getInProgressRate()}</p>
                                <p>Assignments not started: {this.getNotStartedRate()}</p>
                            </Panel.Body>}
                        </Panel>
                    </Col>
                    <Col sm={6} md={6} xs={10} smOffset={1} mdOffset={1} xsOffset={1}>
                        <Row>
                            <Col sm={6} md={6}>
                                <Button bsStyle="primary" onClick={this.printReport}>Print</Button>
                            </Col>
                            <Col sm={6} md={6}>
                                <Button bsStyle="primary" onClick={this.downloadCSV}>Export to CSV</Button>
                            </Col>
                        </Row>
                    </Col>
                </Row>
                <Row>
                    <Col xsOffset={1} xs={10} smOffset={1} sm={10} mdOffset={1} md={10}>
                        {this.displayRecords()}
                    </Col>
                </Row>

                <Clearfix />
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/containers/performanceSummary.js